export default __webpack_public_path__ + "static/media/0xb5c064f955d8e7f38fe0460c556a72987494ee17.e7ad0669.svg";